module.exports = __webpack_public_path__ + "img/ps5_inner_bannner_1.cbbd277c.webp";